import * as Actions from '../../actions/repairTimeGuides/types';

const initialState = {
  loading: false,
  error: '',
  success: '',
  labourGuideData: [],
  vin: '',
};

const laborTimeGuidesReducer = (state = initialState, action) => {
  switch (action.type) {
    // Add Card

    case Actions.GET_REPAIR_TIME_GUIDES_REQUEST:
      return { ...state, loading: true };
    case Actions.GET_REPAIR_TIME_GUIDES_SUCCESS:
      return {
        ...state,
        loading: false,
        labourGuideData: action.payload?.labourGuideData || [],
        success: 'Data added successfully',
        vin: action.payload?.vin || '',
      };
    case Actions.GET_REPAIR_TIME_GUIDES_FAIL:
      return { ...state, loading: false, error: action.payload };
    case Actions.CLEAR_REPAIR_TIME_GUIDES_STATE:
      return {
        ...state,
        loading: false,
        error: '',
        labourGuideData: [],
        vin: '',
        success: '',
      };

    default:
      return state;
  }
};

export default laborTimeGuidesReducer;
